/* Product comparison: "Compare" toggles, the tray at the bottom of the screen, and the compare page.

   Lists are kept per class (tea, teapot, mug, ...; a teapot is never compared with a tea), up to 4 products each,
   in localStorage ("compare-v1"). Toggles are server-rendered buttons (snippets/compare-toggle.liquid) carrying the
   product's id, handle, class, title and image; this script only sets aria-pressed on them (also on cards that
   filters or quick add insert later).
   The compare page (/pages/compare, sections/compare-page.liquid) builds its table from
   /products/<handle>?section_id=compare-product-data, so its values are exactly those of the product-page table.
   A shared link carries the list in the URL fragment: /pages/compare#tea=handle1,handle2 (fragments are not crawled).
   It is imported once (replacing that class's list) and then stripped from the address bar, so a reload or a later
   visit never overwrites what the visitor changed since.
   "Add to cart" buttons in any comparison table ([data-cmp-add]) add one unit and open the cart drawer.
   Config: <script type="application/json" id="compare-config"> from snippets/compare-tray.liquid. */
(function () {
  'use strict';
  if (window.CompareTool) return;
  var node = document.getElementById('compare-config');
  if (!node) return;
  var CFG;
  try { CFG = JSON.parse(node.textContent); } catch (e) { return; }
  var CLASSES = (CFG.schema && CFG.schema.classes) || {};
  var MAX = CFG.max || 4;
  var KEY = 'compare-v1';
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGE = CFG.page || '/pages/compare';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  /* Values from compare-product-data are HTML-escaped by Liquid: turn them back into text before escaping for output. */
  var decoder = document.createElement('textarea');
  function text(s) { decoder.innerHTML = String(s == null ? '' : s).replace(/<[^>]*>/g, ''); return decoder.value; }
  function path(u) { u = String(u || ''); return /^\/(?!\/)/.test(u) || /^https:\/\/cdn\.shopify\.com\//.test(u) || /^\/\/[a-z0-9.-]+\/cdn\//i.test(u) ? u : ''; }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  /* ---- state ---------------------------------------------------------------------------------------------------- */
  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (s && s.lists && typeof s.lists === 'object') return s;
    } catch (e) {}
    return { lists: {}, active: null };
  }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  var state = load();
  function list(c) { return (state.lists[c] = state.lists[c] || []); }
  function classes() { return Object.keys(state.lists).filter(function (c) { return state.lists[c].length && CLASSES[c]; }); }
  function inList(id) { id = String(id); return classes().some(function (c) { return state.lists[c].some(function (x) { return String(x.id) === id; }); }); }
  function label(c) { return (CLASSES[c] && CLASSES[c].label) || 'Products'; }
  function one(c) { return (CLASSES[c] && CLASSES[c].one) || 'product'; }

  function toggle(item) {
    var c = item.c;
    if (!CLASSES[c]) return;
    var l = list(c);
    var i = l.findIndex(function (x) { return String(x.id) === String(item.id); });
    if (i >= 0) {
      l.splice(i, 1);
      say('Removed from compare. ' + label(c) + ': ' + l.length + ' of ' + MAX + '.');
    } else {
      if (l.length >= MAX) {
        state.active = c;
        render();
        say('You can compare up to ' + MAX + ' at a time. Remove one ' + one(c) + ' first.', true); /* after render: the tray is rebuilt there */
        return;
      }
      l.push({ id: String(item.id), h: item.h, t: item.t, img: item.img });
      state.active = c;
      say('Added to compare. ' + label(c) + ': ' + l.length + ' of ' + MAX + '.');
      track('compare_add', { class: c, count: l.length });
    }
    if (!classes().length) state.active = null;
    else if (!state.lists[state.active] || !state.lists[state.active].length) state.active = classes()[0];
    save();
    render();
  }

  /* ---- toggles -------------------------------------------------------------------------------------------------- */
  function paintToggles(root) {
    (root || document).querySelectorAll('[data-compare-toggle]').forEach(function (b) {
      var on = inList(b.dataset.id) ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
    });
  }
  var paintQueued = false;
  function queuePaint() {
    if (paintQueued) return;
    paintQueued = true;
    setTimeout(function () { paintQueued = false; paintToggles(); }, 60);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes' || (m.addedNodes && m.addedNodes.length)) { queuePaint(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
  }

  /* ---- tray ----------------------------------------------------------------------------------------------------- */
  var tray = null, live = null;
  function ensureTray() {
    if (tray) return tray;
    tray = document.createElement('div');
    tray.className = 'cmp-tray';
    tray.setAttribute('role', 'region');
    tray.setAttribute('aria-label', 'Compare products');
    tray.hidden = true;
    document.body.appendChild(tray);
    live = document.createElement('p');
    live.className = 'cmp-live';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);
    return tray;
  }
  var sayTimer = null;
  function say(msg, warn) {
    ensureTray();
    live.textContent = msg;
    tray.dataset.warn = warn ? '1' : '';
    var m = tray.querySelector('.cmp-tray__msg');
    if (m) m.textContent = warn ? msg : '';
    clearTimeout(sayTimer);
    sayTimer = setTimeout(function () { live.textContent = ''; var mm = tray && tray.querySelector('.cmp-tray__msg'); if (mm) mm.textContent = ''; }, 4000);
  }
  function shareHash(c) {
    return '#' + encodeURIComponent(c) + '=' + list(c).map(function (x) { return encodeURIComponent(x.h); }).join(',');
  }
  function renderTray() {
    ensureTray();
    var cs = classes();
    var onPage = !!document.querySelector('[data-compare-page]');
    if (!cs.length || onPage) { tray.hidden = true; document.documentElement.classList.remove('has-cmp-tray'); return; }
    var c = state.active && state.lists[state.active] && state.lists[state.active].length ? state.active : cs[0];
    var l = list(c);
    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var x = l[i];
      slots += x
        ? '<li class="cmp-tray__item"><img src="' + esc(path(x.img)) + '" alt="" width="48" height="48" loading="lazy"><span class="cmp-tray__name">' + esc(x.t) + '</span>' +
          '<button type="button" class="cmp-tray__x" data-cmp-remove="' + esc(x.id) + '" data-cmp-class="' + esc(c) + '" aria-label="Remove ' + esc(x.t) + '">×</button></li>'
        : '<li class="cmp-tray__item cmp-tray__item--empty" aria-hidden="true"></li>';
    }
    var others = cs.filter(function (k) { return k !== c; }).map(function (k) {
      return '<button type="button" class="cmp-tray__other" data-cmp-switch="' + esc(k) + '">' + esc(label(k)) + ' (' + state.lists[k].length + ')</button>';
    }).join('');
    var ready = l.length >= 2;
    var keepMsg = tray.dataset.warn === '1' && tray.querySelector('.cmp-tray__msg') ? tray.querySelector('.cmp-tray__msg').textContent : '';
    tray.innerHTML =
      '<div class="cmp-tray__in">' +
        '<div class="cmp-tray__head"><strong>Compare ' + esc(label(c).toLowerCase()) + '</strong> <span>' + l.length + ' of ' + MAX + '</span>' +
          (others ? '<span class="cmp-tray__others">Also: ' + others + '</span>' : '') + '</div>' +
        '<ul class="cmp-tray__items" role="list">' + slots + '</ul>' +
        '<div class="cmp-tray__actions">' +
          (ready ? '<a class="cmp-tray__go" href="' + esc(PAGE) + '" data-cmp-go="' + esc(c) + '">Compare now</a>'
                 : '<span class="cmp-tray__hint">Add one more ' + esc(one(c)) + ' to compare</span>') +
          '<button type="button" class="cmp-tray__clear" data-cmp-clear="' + esc(c) + '">Clear</button>' +
        '</div>' +
        '<p class="cmp-tray__msg" role="alert">' + esc(keepMsg) + '</p>' +
      '</div>';
    /* theme preview only: Shopify's preview bar covers the bottom and lifts the chat button by its height; lift the
       tray by the same amount so the preview shows what the live store will */
    var pb = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe, iframe[id*="preview-bar"]');
    var lift = pb && pb.getBoundingClientRect().height < 200 ? Math.round(pb.getBoundingClientRect().height) : 0;
    tray.style.setProperty('--cmp-tray-lift', lift + 'px');
    tray.hidden = false;
    document.documentElement.classList.add('has-cmp-tray');
  }

  /* ---- compare page ----------------------------------------------------------------------------------------------- */
  var page = null, pageClass = null, cache = {};
  function fetchProduct(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch(base + 'products/' + encodeURIComponent(h) + '?section_id=compare-product-data')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var s = doc.querySelector('script[data-compare-product]');
        var p = s ? JSON.parse(s.textContent) : null;
        return p && p.id ? p : null;
      })
      .catch(function () { return null; });
    return cache[h];
  }
  function fromHash() {
    var m = /^#([a-z_]+)=([^&]*)$/.exec(window.location.hash || '');
    if (!m || !CLASSES[m[1]]) return null;
    var raw;
    try { raw = decodeURIComponent(m[2]); } catch (e) { return null; } /* a mangled link ("%" alone) is ignored, not fatal */
    var hs = raw.split(',').map(function (x) { return x.trim(); }).filter(function (x) { return /^[a-z0-9][a-z0-9-]*$/i.test(x); }).slice(0, MAX);
    return hs.length ? { c: m[1], hs: hs } : null;
  }
  function stripHash() {
    try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}
  }
  function renderPage() {
    page = document.querySelector('[data-compare-page]');
    if (!page) return;
    var tabs = page.querySelector('[data-compare-tabs]'), bar = page.querySelector('[data-compare-bar]'), box = page.querySelector('[data-compare-table]');
    var cs = classes();
    if (!pageClass || !state.lists[pageClass] || !state.lists[pageClass].length) pageClass = state.active && cs.indexOf(state.active) >= 0 ? state.active : cs[0];
    if (!cs.length) {
      tabs.hidden = true; bar.hidden = true;
      pageClass = null;
      box.innerHTML = '<p class="cmpp__empty">Nothing to compare yet. Tap <strong>Compare</strong> on products you like, for example in ' +
        '<a href="/collections/tea">tea</a> or <a href="/collections/teapots">teapots</a>, then come back here.</p>';
      return Promise.resolve();
    }
    tabs.hidden = cs.length < 2;
    tabs.innerHTML = cs.map(function (c) {
      return '<button type="button" role="tab" class="cmpp__tab" data-cmp-tab="' + esc(c) + '" aria-selected="' + (c === pageClass) + '">' + esc(label(c)) + ' (' + state.lists[c].length + ')</button>';
    }).join('');
    bar.hidden = false;
    var c = pageClass, l = list(c);
    var diff = page.querySelector('.cmpp__diff');
    if (diff) diff.hidden = l.length < 2;
    if (!box.querySelector('table')) box.innerHTML = '<p class="cmpp__empty">Loading…</p>';
    box.setAttribute('aria-busy', 'true');
    var want = l.map(function (x) { return x.h; }).join(',');
    return Promise.all(l.map(function (x) { return fetchProduct(x.h); })).then(function (ps) {
      if (c !== pageClass || want !== list(c).map(function (x) { return x.h; }).join(',')) return; /* a newer render took over */
      var items = [], moved = false;
      ps.forEach(function (p, i) {
        var x = l[i];
        if (p && p.c === c) { items.push(p); if (x.id !== String(p.id)) { x.id = String(p.id); x.t = p.t; x.img = p.img || ''; moved = true; } }
        else if (p && p.c && CLASSES[p.c]) {
          /* a shared link can name a product of another class: it goes to its own list, never into this table */
          var o = list(p.c);
          if (!o.some(function (y) { return String(y.id) === String(p.id); }) && o.length < MAX) o.push({ id: String(p.id), h: p.h, t: p.t, img: p.img || '' });
          x.drop = true; moved = true;
        } else items.push({ gone: true, t: x.t, h: x.h, id: x.id }); /* deleted, unpublished or no longer comparable: removable column */
      });
      if (moved) {
        state.lists[c] = l.filter(function (x) { return !x.drop; });
        save();
        return renderPage();
      }
      box.innerHTML = tableHtml(c, items);
      box.removeAttribute('aria-busy');
      applyDiff();
      paintToggles();
    });
  }
  var NONE = '<span class="cmps__none"><span aria-hidden="true">—</span><span class="visually-hidden">Not listed</span></span>';
  function tableHtml(c, items) {
    var spec = CLASSES[c];
    var keys = [['price', 'Price']];
    if (c === 'tea') keys.push(['ppc', 'Price per cup']);
    keys.push(['rating', 'Customer rating']);
    (spec.rows || []).forEach(function (r) { if (r.k !== 'ppc') keys.push([r.k, r.label]); });
    var head = '<tr><td class="cmps__corner"></td>' + items.map(function (p) {
      var rm = '<button type="button" class="cmps__remove" data-cmp-remove="' + esc(p.id) + '" data-cmp-class="' + esc(c) + '" aria-label="Remove ' + esc(p.t) + '">×</button>';
      if (p.gone) return '<th scope="col" class="cmps__col">' + rm + '<div class="cmps__media"><span class="cmps__img"></span></div><span class="cmps__title">' + esc(text(p.t)) + '</span><div class="cmps__actions"><span class="cmps__sold">No longer available</span></div></th>';
      var buy = !p.avail ? '<span class="cmps__sold">Sold out</span>'
        : p.single ? '<button type="button" class="cmps__buy" data-cmp-add="' + esc(p.vid) + '">Add to cart</button>'
        : '<a class="cmps__buy cmps__buy--link" href="' + esc(path(p.url)) + '">See options</a>';
      return '<th scope="col" class="cmps__col">' + rm +
        '<div class="cmps__media"><a class="cmps__img" href="' + esc(path(p.url)) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(path(p.img)) + '" alt="" width="150" height="150" loading="lazy">' : '') + '</a></div>' +
        '<a class="cmps__title" href="' + esc(path(p.url)) + '" title="' + esc(text(p.t)) + '">' + esc(text(p.t)) + '</a><div class="cmps__actions">' + buy + '</div></th>';
    }).join('') + (items.length < MAX ? '<th scope="col" class="cmps__col"><a class="cmps__add-slot" href="' + esc(path(spec.url) || '/collections/all') + '"><span aria-hidden="true">+</span>Add ' + esc(label(c).toLowerCase()) + '</a></th>' : '') + '</tr>';
    var rows = keys.map(function (kv) {
      var vals = items.map(function (p) { return p.gone ? '' : text((p.v && p.v[kv[0]]) || '').trim(); });
      var filled = vals.filter(Boolean).length;
      if (filled < 1 || (items.length > 1 && filled < 2 && kv[0] !== 'price')) return '';
      var same = vals.every(function (v) { return v === vals[0]; });
      return '<tr' + (same ? ' data-same="1"' : '') + '><th scope="row" class="cmps__label">' + esc(kv[1]) + '</th>' +
        vals.map(function (v) { return '<td class="cmps__val">' + (v ? esc(v) : NONE) + '</td>'; }).join('') +
        (items.length < MAX ? '<td class="cmps__val"></td>' : '') + '</tr>';
    }).join('');
    return '<div class="cmps"><div class="cmps__scroll" tabindex="0" role="region" aria-label="Comparison table"><table class="cmps__table"><thead>' + head + '</thead><tbody>' + rows + '</tbody></table></div></div>' +
      (items.length < 2 ? '<p class="cmpp__empty">Add at least one more ' + esc(one(c)) + ' to compare.</p>' : '');
  }
  function applyDiff() {
    if (!page) return;
    var cb = page.querySelector('[data-compare-diff]');
    var on = !!(cb && cb.checked && !cb.closest('[hidden]'));
    page.querySelectorAll('tr[data-same]').forEach(function (tr) { tr.classList.toggle('is-same', on); });
  }

  function render() {
    renderTray();
    paintToggles();
    if (page || document.querySelector('[data-compare-page]')) return renderPage() || Promise.resolve();
    return Promise.resolve();
  }
  /* Keyboard users stay where they were after a remove: the next remove button of the same list, else the list itself. */
  function refocus(root, idx, fallback) {
    var bs = root && !root.hidden ? root.querySelectorAll('[data-cmp-remove]') : [];
    var el = bs[idx] || bs[idx - 1] || (fallback && fallback());
    if (!el) return;
    if (!/^(A|BUTTON|INPUT)$/.test(el.tagName) && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  /* ---- events ----------------------------------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var tg = t.closest && t.closest('[data-compare-toggle]');
    if (tg) {
      e.preventDefault();
      e.stopPropagation();
      toggle({ id: tg.dataset.id, h: tg.dataset.h, c: tg.dataset.c, t: tg.dataset.t, img: tg.dataset.img });
      return;
    }
    var rm = t.closest && t.closest('[data-cmp-remove]');
    if (rm) {
      e.preventDefault();
      var c = rm.dataset.cmpClass, l = list(c);
      var root = rm.closest('.cmp-tray') || rm.closest('[data-compare-page]');
      var idx = root ? Array.prototype.indexOf.call(root.querySelectorAll('[data-cmp-remove]'), rm) : -1;
      var i = l.findIndex(function (x) { return String(x.id) === String(rm.dataset.cmpRemove); });
      if (i >= 0) l.splice(i, 1);
      if (!l.length && state.active === c) state.active = classes()[0] || null;
      save();
      var inTray = root === tray;
      render().then(function () {
        refocus(inTray ? tray : page, idx, function () {
          return inTray ? (tray.hidden ? null : tray.querySelector('.cmp-tray__go, .cmp-tray__clear')) : page && page.querySelector('.cmpp__h1');
        });
      });
      say('Removed from compare.');
      return;
    }
    var go = t.closest && t.closest('[data-cmp-go]');
    if (go) { state.active = go.dataset.cmpGo; save(); return; }
    var clr = t.closest && t.closest('[data-cmp-clear], [data-compare-clear]');
    if (clr) {
      e.preventDefault();
      var cc = clr.dataset.cmpClear || pageClass;
      if (cc) state.lists[cc] = [];
      state.active = classes()[0] || null;
      var fromTray = !!clr.closest('.cmp-tray');
      if (clr.hasAttribute('data-compare-clear')) pageClass = null;
      save();
      render().then(function () {
        refocus(fromTray ? tray : page, -1, function () {
          return fromTray ? (tray.hidden ? document.getElementById('MainContent') : tray.querySelector('.cmp-tray__go, .cmp-tray__clear')) : page && page.querySelector('.cmpp__h1');
        });
      });
      return;
    }
    var sw = t.closest && t.closest('[data-cmp-switch]');
    if (sw) {
      e.preventDefault();
      state.active = sw.dataset.cmpSwitch; save(); renderTray();
      refocus(tray, -1, function () { return tray.querySelector('.cmp-tray__go, .cmp-tray__clear'); }); /* the clicked button was rebuilt */
      return;
    }
    var tab = t.closest && t.closest('[data-cmp-tab]');
    if (tab) {
      e.preventDefault();
      pageClass = tab.dataset.cmpTab; state.active = pageClass; save();
      renderPage();
      var sel = page && page.querySelector('[data-cmp-tab][aria-selected="true"]'); /* tabs are rebuilt: focus the new one */
      if (sel) sel.focus();
      return;
    }
    var sh = t.closest && t.closest('[data-compare-share]');
    if (sh) {
      e.preventDefault();
      var url = window.location.origin + window.location.pathname + shareHash(pageClass);
      var msg = page && page.querySelector('[data-compare-msg]');
      (navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(url) : Promise.reject())
        .then(function () { if (msg) msg.textContent = 'Link copied.'; }, function () { if (msg) msg.textContent = url; });
      return;
    }
    var add = t.closest && t.closest('[data-cmp-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      var txt = add.textContent;
      add.textContent = 'Adding…';
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.cmpAdd), quantity: 1 }] }) })
        .then(function (r) {
          if (r.ok) return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } });
          return r.json().catch(function () { return {}; }).then(function (j) { throw new Error((j && (j.description || j.message)) || 'Could not add to cart'); });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: cart, sourceId: 'compare', data: { source: 'compare', itemCount: cart.item_count } };
          document.dispatchEvent(ev);
          add.textContent = 'Added ✓';
          track('compare_add_to_cart', {});
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          setTimeout(function () { add.textContent = txt; add.disabled = false; }, 1800);
        })
        .catch(function (err) {
          /* sold out since the page loaded, quantity limit, network: say so next to the button (the tray may be hidden) */
          var msg = String((err && err.message) || 'Could not add to cart').replace(/<[^>]*>/g, '');
          add.textContent = 'Not added';
          var er = add.nextElementSibling && add.nextElementSibling.classList.contains('cmps__err') ? add.nextElementSibling : null;
          if (!er) {
            er = document.createElement('span');
            er.className = 'cmps__err';
            er.setAttribute('role', 'alert');
            add.insertAdjacentElement('afterend', er);
          }
          er.textContent = msg;
          setTimeout(function () { add.textContent = txt; add.disabled = false; }, 2500);
          setTimeout(function () { if (er.parentNode) er.parentNode.removeChild(er); }, 6000);
        });
    }
  }, true);
  document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('[data-compare-diff]')) applyDiff(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { state = load(); render(); } });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { state = load(); render(); } });

  function init() {
    /* A shared link replaces the list of that class, once: the fragment is removed right after (renderPage then
       fills ids / titles / images of handles it did not know and moves other-class products to their own list). */
    var onPage = !!document.querySelector('[data-compare-page]');
    var fh = onPage && fromHash();
    if (onPage && window.location.hash) stripHash();
    if (fh) {
      var known = {};
      list(fh.c).forEach(function (x) { known[x.h] = x; });
      state.lists[fh.c] = fh.hs.map(function (h) { return known[h] || { id: 'h:' + h, h: h, t: h.replace(/-/g, ' '), img: '' }; });
      state.active = fh.c;
      pageClass = fh.c;
      save();
    }
    render();
  }
  window.CompareTool = { toggle: toggle, render: render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
